import { render } from "./ImagePolygonOutline.vue?vue&type=template&id=21ca95cc&scoped=true&ts=true"
import script from "./ImagePolygonOutline.vue?vue&type=script&lang=ts"
export * from "./ImagePolygonOutline.vue?vue&type=script&lang=ts"

import "./ImagePolygonOutline.vue?vue&type=style&index=0&id=21ca95cc&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ca95cc"]])

export default __exports__